import React, {useMemo, useState} from "react";
import {useTranslate} from "../../../../../hooks/translate.hook";
import {Form, Input, Modal} from "antd";
import {PropertyLocation} from "../../../../../models/property/property";
import {propertyService} from "../../../../../services/property/property.service";

interface EditPropertyTypeModalProps {
    onClose: () => void;
    location?: PropertyLocation | null;
}
export const EditPropertyLocationModal: React.FC<EditPropertyTypeModalProps> = ({ onClose, location }) => {
    const t = useTranslate();
    const [loading, setLoading] = useState<boolean>(false);
    const [form] = Form.useForm();

    const initialValues = useMemo(() => {
        let values: any = {}
        if (location) {
            values = {
                name: location.name,
                code: location.code
            }
        }

        return values;
    }, [])

    return (
        <Modal
            visible={true}
            confirmLoading={loading}
            title={t("PROPERTY.PROPERTY.LOCATION")}
            okText={t("SAVE")}
            cancelText={t("CANCEL")}
            onOk={() => form.submit()}
            onCancel={onClose}
            maskClosable={false}
        >
            <Form
                form={form}
                layout="vertical"
                name={"integrations_form"}
                initialValues={initialValues}
                onFinish={() => form
                    .validateFields()
                    .then(async values => {
                        setLoading(true);
                        try {
                            if (location) {
                                await propertyService.editLocation(location.id, values);
                                onClose();
                            } else {
                                await propertyService.createLocation(values);
                                onClose();
                            }
                        } finally {
                            setLoading(false);
                        }
                    })
                }
            >
                <Form.Item
                    label={t("PROPERTY.LOCATION.CODE")}
                    name="code"
                    rules={[
                        {
                            required: true,
                            message: t(
                                "FROM.ERROR.PLEASE_SELECT_VALUE"
                            ),
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label={t("PROPERTY.LOCATION.NAME")}
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: t(
                                "FROM.ERROR.PLEASE_SELECT_VALUE"
                            ),
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
            </Form>

        </Modal>
    );
}